import { ReactNode } from 'react';
import styles from './AspectRatioContainer.module.css';

interface CommonProps {
  /** Allows you to specify an additional CSS class for the inner container. This is useful for attaching pseudo elements to. Avoid changing position, top, bottom, left, right. */
  innerClassName?: string;
  children: ReactNode;
}

/** Allows the aspect ratio to be defined statically with values from javascript (E.g. hardcode or calculated using javascript */
interface ExplicitSizes {
  useCssVariableSizes?: false|undefined;
  width: number;
  height: number;
}

/** Allows the aspect ratio to be defined with CSS varaibles --aspect-ratio-container-width and --aspect-ratio-container-height.
 * These variables should be specified on an ancestor element
 */
interface SizesViaCssVariables {
  useCssVariableSizes: true;
}

type Props = CommonProps & (ExplicitSizes | SizesViaCssVariables)
const AspectRatioContainer = (props: Props) => {
  return (
    <div
      className={styles.outer + ' ' + (props.useCssVariableSizes ? styles.withCssVariables : '')}
      style={props.useCssVariableSizes ? undefined : { paddingTop: (props.height / props.width) * 100 + "%" }}>
      <div className={styles.inner + ' ' + (props.innerClassName || '')}>
        {props.children}
      </div>
    </div>
  );
}

export default AspectRatioContainer;